import React, { memo } from 'react';
import styled from 'styled-components';
import lockIcon from '../../assets/icons/ic_locked_session.svg';

const StyledLockIcon = styled.i`
  background: url(${lockIcon}) 0 0 no-repeat;
  background-size: contain;
  position: absolute;
  pointer-events: none;
  z-index: 2;
  top: ${(props) => (props.isSmall ? '12px' : '18px')};
  right: ${(props) => (props.isSmall ? '12px' : '18px')};
  width: ${(props) => (props.isSmall ? '18px' : '24px')};
  height: ${(props) => (props.isSmall ? '24px' : '32px')};
  opacity: 0.85;
`;

const LockIcon = ({ isSmall }) => <StyledLockIcon isSmall={isSmall} />;

export default memo(LockIcon);
